import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { useMemo } from "react";
import type { ComponentProps, FC } from "react";

import { DATEPICKER_DATE_FORMAT } from "consts";

import DatePicker from "./DatePicker";

type Props = Omit<ComponentProps<typeof DatePicker>, "value" | "onChange"> & {
  value?: string;
  onChange?: (value: string | undefined) => void;
};

const DateStringPicker: FC<Props> = ({ value, onChange, ...props }) => {
  const valueAsDayjs = value ? dayjs(value) : undefined;
  const onChangeDayjs = useMemo(
    () => (value: Dayjs | null) => onChange?.(value?.format(DATEPICKER_DATE_FORMAT)),
    [onChange]
  );

  return (
    <DatePicker
      {...props}
      value={valueAsDayjs}
      onChange={(date) => onChangeDayjs(date as Dayjs)}
    />
  );
};

export default DateStringPicker;
